import { Color } from '@tmh-website/shared/colors';
import { StyledButton } from '@tmh-website/ui/Button';
import styled from 'styled-components';

export const Container = styled.div`
  padding: 12px 0;
`;

export const LoggedOutContainer = styled.div`
  padding: 12px 24px ${props => props.theme.gap.small};
  border-bottom: 1px solid ${props => props.theme.color[Color.Neutral_400]};
`;

export const LoginButtonContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.gap.xSmall};
  justify-content: center;
  margin-bottom: ${props => props.theme.gap.xSmall};

  ${StyledButton.ButtonContainer} {
    flex-grow: 1;
  }
`;

export const Line = styled.hr`
  border: none;
  border-bottom: 1px solid ${props => props.theme.color[Color.Neutral_500]};
`;
